export default __webpack_public_path__ + "static/media/leo_lion_roar.370903c7.gif";